export default __webpack_public_path__ + "static/media/venus_gines_07022021_mixdown_0823-0914.d5b0781f.wav";